export class Acao {
    acaoId: number;
    nome: string;

    constructor(grupoDto: any) {
        this.acaoId = grupoDto?.acaoID;
        this.nome = grupoDto?.nome?.replace(/[_]/g, ' ');
    }
}
